
import { Component, inject, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { ModelService } from '../../../services/model-service';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { GuruEntity } from '../../../model/guru-entity';
import { SelectionUtils } from '../../selection-utils';

@Component({
  selector: 'app-enviro-kit-controls',
  imports: [MatIcon, FormsModule],
  templateUrl: './enviro-kit-controls.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './enviro-kit-controls.component.css'
})
export class EnviroKitControlsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  controlVoltageSelection!: GuruEntity;
  condensateSwitchSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CONTROLS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.controlVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlVoltage');
    this.condensateSwitchSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCondensateSwitch');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
    entity.Value = newValue;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
